import * as React from "react";
const IconAddExpert = (props) => (
  <svg
    width={25}
    height={24}
    viewBox="0 0 25 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.98633 14.9924C10.9322 13.6726 12.6861 13.6456 15.9863 14.9924"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle
      cx={3}
      cy={3}
      r={3}
      transform="matrix(1 0 0 -1 8.98633 10.9924)"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinejoin="round"
    />
    <path
      d="M20.7633 12.9924C20.9093 12.3492 20.9863 11.6798 20.9863 10.9924C20.9863 6.02187 16.9569 1.99243 11.9863 1.99243C7.01577 1.99243 2.98633 6.02187 2.98633 10.9924C2.98633 15.963 7.01577 19.9924 11.9863 19.9924C12.6737 19.9924 13.3431 19.9154 13.9863 19.7694"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M18.9863 15.9924V19.9924"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
    <path
      d="M20.9863 17.9924L16.9863 17.9924"
      stroke={props.color || "#1C1C2C"}
      strokeWidth={1.5}
      strokeLinecap="round"
    />
  </svg>
);
export default IconAddExpert;
